<div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body py-0">
    <div>
        <video #videoElement
            class="video-element mx-auto mw-100 w-100 rounded-4"
            [ngClass]="[
                isImageCaptured ? 'd-none' : 'd-block',
                mirrorCameraState ? 'mirrored' : ''
            ]"
            allow="camera *" 
            autoplay 
            allowusermedia 
            playsinline 
            muted>
        </video>
        <canvas #canvasElement id="canvasElement" 
            class="mx-auto mw-100 w-100"
            [ngClass]="isImageCaptured ? 'd-block' : 'd-none'">
        </canvas>
    </div>
</div>

<div class="modal-footer justify-content-between gap-4">
    <ng-container *ngIf="isImageCaptured">
        <button class="btn outline-btn" 
            (click)="repeatImageCapture()">
            <i class="app-icon icon icon-image-re-take icon-xl me-2"></i>
            <span>{{ 'common.reScan' | translate }}</span>
        </button>
        <button class="btn primary-btn" 
            (click)="closeModalWithImageData(capturedImageFile)">
            <span>{{ 'common.confirmButton' | translate }}</span>
        </button>
    </ng-container>

    <ng-container *ngIf="!isImageCaptured">
        <div class="flex-grow-1" *ngIf="camerasArray && camerasArray.length > 2">
            <label class="label-input">
                {{ "common.switchCamera" | translate }}
            </label>
            <kendo-dropdownlist 
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [data]="camerasArray"
                [size]="sizeLarge"
                textField="deviceLabel"
                valueField="deviceId"
                [value]="camerasArray[activeCameraIndex]"
                (valueChange)="onActiveWebcamChange($event)"
                [popupSettings]="{ 
                    appendTo : 'component' 
                }">
                <kendo-dropdownlist-messages
                    noDataText="{{ 'common.noData' | translate }}"
                ></kendo-dropdownlist-messages>
            </kendo-dropdownlist>
        </div>    

        <button *ngIf="camerasArray && camerasArray.length === 2" 
            class="btn outline-btn" 
            (click)="onActiveWebcamChange()">
            <i class="app-icon icon icon-rotate icon-xl me-2"></i>
            <span>{{ 'common.switchCamera' | translate }}</span>
        </button>

        <button class="btn outline-btn" 
            (click)="mirrorCamera(!mirrorCameraState)">
            <i class="app-icon icon icon-flip-horizontal icon-xl me-2"></i>
            <span>{{ 'common.flipCamera' | translate }}</span>
        </button>

        <button class="btn primary-btn" 
            (click)="imageCapture()">
            <i class="app-icon icon icon-image-take icon-xl me-2"></i>
            <span>{{ 'common.scan' | translate }}</span>
        </button>
    </ng-container>
</div>
